<app-ui-document-panel-shell
  [breadcrumb]="breadcrumb"
  [title]="panelTitle"
  [documentId]="voucherNo || ''"
  [statusLabel]="statusLabel"
  [statusVariant]="statusVariant"
  (closed)="onClose()">

  <div class="voucher-panel">
    <app-ui-approval-stepper [steps]="approvalSteps"></app-ui-approval-stepper>

    <app-ui-form-section title="General Information" icon="info">
      <div class="voucher-panel__field-grid">
        <div class="voucher-panel__field">
          <mat-form-field appearance="outline">
            <mat-label>Voucher Type<span class="ui-doc-panel-content__required">*</span></mat-label>
            <mat-select [(ngModel)]="voucherType" #dataRef (ngModelChange)="fetchvouchertype(dataRef.value);"
              placeholder="Select Voucher Type" [disabled]="isUpdate || isInputDisabled">
              <mat-option *ngFor="let item of vouchers" [value]="item.id">{{ item.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="voucher-panel__field"
          *ngIf="!voucher_type || voucher_type == 'Purchase' || voucher_type == 'Sales' || voucher_type == 'Receipt Voucher' || voucher_type == 'Credit Note' || voucher_type == 'Debit Note'">
          <mat-form-field appearance="outline">
            <mat-label>Branch<span class="ui-doc-panel-content__required">*</span></mat-label>
            <mat-select [(ngModel)]="branch" #branch_id (ngModelChange)="onBranchChangeWithLedger(branch_id.value)"
              placeholder="Select Branch" [disabled]="isUpdate || isInputDisabled">
              <mat-option *ngFor="let type of branchdata" [value]="type.id">{{ type.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="voucher-panel__field"
          *ngIf="voucher_type == 'Purchase' || voucher_type == 'Sales' || voucher_type == 'Credit Note' || voucher_type == 'Debit Note'">
          <mat-form-field appearance="outline">
            <mat-label>Profit Cost<span class="ui-doc-panel-content__required">*</span></mat-label>
            <mat-select [(ngModel)]="profit_cost_id" placeholder="Select Profit Cost"
              (ngModelChange)="onProfitCost($event)" [disabled]="isUpdate || isInputDisabled" multiple>
              <mat-option *ngFor="let profitcost of profit_cost" [value]="profitcost.id">
                {{ profitcost.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
         <div class="voucher-panel__field" *ngIf="voucher_type === 'Sales'">
          <mat-form-field appearance="outline">
            <mat-label>Section</mat-label>
            <mat-select [(ngModel)]="selectedSection" placeholder="Select Section"
              (selectionChange)="onSectionChange($event.value)" [disabled]="isUpdate || isInputDisabled" multiple>
              <mat-option *ngFor="let item of filteredSections" [value]="item.id">{{ item.section_name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="voucher-panel__field">
          <mat-form-field appearance="outline">
            <mat-label>Date<span class="ui-doc-panel-content__required">*</span></mat-label>
            <input type="date" matInput [(ngModel)]="date" placeholder="DD/MM/YYYY"
              [attr.min]="invoice_date || null" [max]="maxDate" [disabled]="isInputDisabled" (keydown)="$event.preventDefault()">
          </mat-form-field>
        </div>
      </div>
    </app-ui-form-section>

    <app-ui-form-section title="Customer Details" icon="person">
      <div class="voucher-panel__field-grid">
        <div class="voucher-panel__field voucher-panel__field--wide" *ngIf="voucher_type === 'Sales'">
          <mat-form-field appearance="outline">
            <mat-label>Select Customer</mat-label>
            <mat-select [(ngModel)]="customer" placeholder="Select Customer"
              (selectionChange)="onCustomerChange($event.value)" [disabled]="isUpdate || isInputDisabled">
              <mat-option *ngFor="let item of customerData" [value]="item.id">{{ item.customer_name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="voucher-panel__field" *ngIf="customerBranchData && customerBranchData.length > 0">
          <mat-form-field appearance="outline">
            <mat-label>Customer Branch</mat-label>
            <mat-select [(ngModel)]="selectedCustomerBranch" placeholder="Select Customer Branch"
              (selectionChange)="gstType();onCustomerBranchChange($event.value)" [disabled]="isUpdate || isInputDisabled">
              <mat-option *ngFor="let item of customerBranchData" [value]="item.id">{{ item.branch_name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="voucher-panel__field voucher-panel__field--with-action" *ngIf="voucher_type === 'Sales'">
          <mat-form-field appearance="outline">
            <mat-label>GSSN<span class="ui-doc-panel-content__required">*</span></mat-label>
            <mat-select [(ngModel)]="selectedGsn" multiple placeholder="Select GSSN"
              [disabled]="selectedItem || data.approval_status === 'Pending' || isInputDisabled">
              <mat-option *ngFor="let item of gsn" [value]="item.id">
                {{ item.gsn_no }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <button *ngIf="!isInputDisabled" mat-raised-button color="primary" type="button"
            class="voucher-panel__search-btn" (click)="onSearchClick()"
            [disabled]="(!selectedGsn || selectedGsn.length === 0) || data.approval_status === 'Pending'">
            Search
          </button>
        </div>
      </div>
        </app-ui-form-section>
        <app-ui-form-section title="Document Details" icon="description">
        <div class="voucher-panel__field-grid">
        <div class="voucher-panel__field">
          <mat-form-field appearance="outline">
            <mat-label>External Document No.<span class="ui-doc-panel-content__required">*</span></mat-label>
            <input matInput type="text" [(ngModel)]="document_no" placeholder="External Document No"
              [disabled]="data.approval_status === 'Pending' || isInputDisabled">
          </mat-form-field>
        </div>

        <div class="voucher-panel__field">
          <mat-form-field appearance="outline">
            <mat-label>Document Date<span class="ui-doc-panel-content__required">*</span></mat-label>
            <input type="date" matInput [(ngModel)]="issue_date" placeholder="DD/MM/YYYY" [max]="maxDate"
              [disabled]="data.approval_status === 'Pending' || isInputDisabled" (keydown)="$event.preventDefault()">
          </mat-form-field>
        </div>

        <div class="voucher-panel__field" *ngIf="productList.length > 0">
          <mat-form-field appearance="outline">
            <mat-label>Rounded Ledger</mat-label>
            <mat-select #ledgerSelect [(ngModel)]="ledger" panelClass="ledger-select-panel"
              [disabled]="isInputDisabled"
              (openedChange)="onLedgerOpen($event)">
              <mat-option disabled>
                <input matInput placeholder="Search Ledger..." (keyup)="filterLedger($event)"
                  (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" />
              </mat-option>
              <mat-option [value]="null">Select Ledger</mat-option>
              <mat-option *ngFor="let item of rounded_ledger_data" [value]="item.ledger_id">
                {{ item.ledger_name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="voucher-panel__field" *ngIf="productList.length > 0">
          <mat-form-field appearance="outline">
            <mat-label>Rounded</mat-label>
            <input matInput type="number" [(ngModel)]="roundedamount2" placeholder="Rounded Amount"
              [disabled]="isInputDisabled">
          </mat-form-field>
        </div>
      </div>
    </app-ui-form-section>

    <app-ui-form-section *ngIf="is_pi_si_manual == 1" title="Manual Line Entry" icon="add_box" [showHeaderActions]="!isInputDisabled">
      <button *ngIf="!isInputDisabled" sectionActions mat-stroked-button color="primary" type="button" (click)="addProduct()">
        <mat-icon>add</mat-icon> Add Row
      </button>
      <div class="voucher-panel__field-grid">
        <div class="voucher-panel__field voucher-panel__field--wide">
          <mat-form-field appearance="outline">
            <mat-label>SKU / Service<span class="ui-doc-panel-content__required">*</span></mat-label>
            <mat-select [(ngModel)]="selectedItem" (ngModelChange)="onSelectionChange($event)"
              placeholder="Select SKU/Services" [disabled]="isInputDisabled">
              <ng-container *ngFor="let group of combinedDropdownData">
                <mat-optgroup [label]="group.category">
                  <mat-option *ngFor="let item of group.items" [value]="item">
                    {{ item.item_name || item.service_name }}
                  </mat-option>
                </mat-optgroup>
              </ng-container>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="voucher-panel__field">
          <mat-form-field appearance="outline">
            <mat-label>HSN/SAC No</mat-label>
            <input matInput type="text" [(ngModel)]="hsn_no" placeholder="HSN/SAC No" disabled>
          </mat-form-field>
        </div>
        <div class="voucher-panel__field voucher-panel__field--wide">
          <mat-form-field appearance="outline">
            <mat-label>Description<span class="ui-doc-panel-content__required">*</span></mat-label>
            <input matInput type="text" [(ngModel)]="selectedDescription" placeholder="Enter Description" disabled>
          </mat-form-field>
        </div>
        <div class="voucher-panel__field">
          <mat-form-field appearance="outline">
            <mat-label>UoM</mat-label>
            <input matInput type="text" [(ngModel)]="unit" placeholder="UoM" disabled>
          </mat-form-field>
        </div>
        <div class="voucher-panel__field">
          <mat-form-field appearance="outline">
            <mat-label>Qty<span class="ui-doc-panel-content__required">*</span></mat-label>
            <input matInput type="number" [(ngModel)]="selectedQty" placeholder="QTY"
              (keypress)="allowOnlyNumbers($event)" min="1" [disabled]="isInputDisabled">
          </mat-form-field>
        </div>
        <div class="voucher-panel__field">
          <mat-form-field appearance="outline">
            <mat-label>Unit Price<span class="ui-doc-panel-content__required">*</span></mat-label>
            <input matInput type="number" [(ngModel)]="selectedUnitPrice" placeholder="Unit Price"
              (keypress)="allowOnlyNumbers($event)" min="1" [disabled]="isInputDisabled">
          </mat-form-field>
        </div>
        <div class="voucher-panel__field">
          <mat-form-field appearance="outline">
            <mat-label>Discount(%)</mat-label>
            <input matInput type="number" [(ngModel)]="selectedDiscount" placeholder="Discount"
              (keypress)="allowOnlyNumbers($event)" min="0" [disabled]="isInputDisabled">
          </mat-form-field>
        </div>
        <div class="voucher-panel__field">
          <mat-form-field appearance="outline">
            <mat-label>Tax<span class="ui-doc-panel-content__required">*</span></mat-label>
            <mat-select [(ngModel)]="selectedTaxType" placeholder="Select Tax" [disabled]="isInputDisabled">
              <mat-option *ngFor="let item of tax" [value]="item.global_gst_id">{{ item.gst_percentage }}%</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </app-ui-form-section>

    <app-ui-form-section *ngIf="selectedGsn && selectedGsn.length > 0" title="Line Items" icon="view_list">
      <div class="voucher-panel__table-wrap" *ngIf="productList.length > 0">
        <table class="voucher-panel__table">
          <thead>
            <tr>
              <th>GSSN No</th>
              <th>Section</th>
              <th>Profit Cost</th>
              <th>Line Document No</th>
              <th>Product Service No</th>
              <th>Category Name</th>
              <th>Item/service Name</th>
              <th>HSN/SAC No</th>
              <th>Description</th>
              <th>Units</th>
              <th>QTY</th>
              <th>Unit Price</th>
              <th>Actual Value</th>
              <th>Discounted Amount</th>
              <th>Incentive Amount</th>
              <th>Final value</th>
              <th>CGST</th>
              <th>SGST</th>
              <th>IGST</th>
              <th>Gst Amount</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let product of productList">
              <ng-container *ngFor="let detail of product.details; let i = index">
                 <tr>
                  <td>{{detail?.gsn?.gsn_no}}</td>
                  <td>{{ detail?.section?.section_name }}</td>
                  <td>{{ detail?.profit_cost?.name }}</td>
                  <td>{{ detail.line_document_no }}</td>
                  <td>{{ detail.product_service_no }}</td>
                  <td>{{
                    detail.item_service_type === 'SKU'
                    ? detail?.sku?.profit_cost_category?.category?.category_name
                    : detail.item_service_type === 'Service'
                    ? detail?.service?.profit_cost_category?.category?.category_name
                    : detail.item_service_type === 'Fixed Asset'
                    ? detail?.fa_template?.home_entity_category?.category_name
                    : ''
                    }}</td>                  
                  <td>
                    {{
                    detail.item_service_type === 'SKU'
                    ? detail?.sku?.item?.item_name
                    : detail.item_service_type === 'Service'
                    ? detail?.service?.service_name
                    : detail.item_service_type === 'Fixed Asset'
                    ? detail?.fa_template?.name
                    : ''
                    }}
                  </td>
                  <td>{{ detail.item_service_type === 'SKU'
                    ? detail.hsn_no
                    : detail.item_service_type === 'Service'
                    ? detail?.hsn_no
                    : detail.item_service_type === 'Fixed Asset'
                    ? detail?.hsn_no
                    : ''}}</td>
                  <td>{{ detail.description }}</td>
                  <td>{{ detail.unit.unit_name }}</td>     
                  <td>{{ selectedGrn.length !==0 ? detail.receive_qty : detail.send_qty | number:'1.3-3' }}</td>
                  <td>{{ detail.unit_price | number:'1.2-2' }}</td>
                  <td>{{ (selectedGrn.length !==0 ? detail.receive_qty * detail.unit_price : detail.send_qty *
                    detail.unit_price) | number:'1.2-2' }}</td>
                  <td>
                    <span>{{ detail.discount_amount | number:'1.2-2' }}</span>
                  </td>
                  <td>
                    <span>{{ detail.incentive_amount | number:'1.2-2' }}</span>
                  </td>
                  <td>{{(selectedGrn.length !==0 ? detail.receive_qty * detail.unit_price : detail.send_qty *
                    detail.unit_price) - detail?.discount_amount + detail?.incentive_amount | number:'1.2-2' }}</td>
                  <td>{{ cgstAmount(detail)}} <span *ngIf="gstMatch() && vendorBranchGstType === 'REGISTER'">({{
                      getCGSTPercentage(detail.hsn_sac.gst_id)
                      }}%)</span></td>
                  <td>{{ sgstAmount(detail)}} <span *ngIf="gstMatch() && vendorBranchGstType === 'REGISTER'">({{
                      getSGSTPercentage(detail.hsn_sac.gst_id)
                      }}%)</span></td>
                  <td>{{ igstAmount(detail)}} <span *ngIf="gstMatch() === false && vendorBranchGstType === 'REGISTER'">({{
                      getIGSTPercentage(detail.hsn_sac.gst_id) }}%)</span></td>
                  <td>{{productTaxAmount2(detail) | number:'1.2-2' }}</td>
                  </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
      <p *ngIf="!productList?.length" style="color:#6B7280;font-size:13px;">Search GSSN to load line items.</p>
    </app-ui-form-section>

    <div class="voucher-panel__bottom">
      <div class="voucher-panel__bottom-left">
        <!-- <app-ui-form-section title="Approval Details" icon="verified"> -->
          <mat-form-field appearance="outline" class="voucher-panel__narration">
            <mat-label>Narration<span class="ui-doc-panel-content__required">*</span></mat-label>
            <textarea matInput [(ngModel)]="purchesnarration" placeholder="Enter narration..." rows="4"
              [disabled]="data.approval_status === 'Pending' || isInputDisabled"></textarea>
          </mat-form-field>
        <!-- </app-ui-form-section> -->

        <app-ui-form-section title="Attachments" icon="attach_file">
          <app-ui-document-file-upload
            [disabled]="isInputDisabled"
            [files]="myFiles"
            [showViewLink]="!!data?.id && operationType !== 'create'"
            (filesSelected)="onFileSelected($event)"
            (removeFile)="removeFile($event)"
            (viewFiles)="openVoucherFileShowModal()">
          </app-ui-document-file-upload>
        </app-ui-form-section>
      </div>

      <aside class="voucher-panel__summary">
        <ng-container *ngIf="productList.length > 0; else emptySummary">
          <div class="voucher-panel__summary-row">
            <span>Total Discount</span>
            <span class="voucher-panel__summary-value"> {{ getTotaldiscount2() | number: '1.2-2' }}</span>
          </div>
           <div class="voucher-panel__summary-row" *ngIf="getTotalDiscountAmount() > 0">
            <span>Total Discounted Amounts</span>
              <span class="voucher-panel__summary-value">{{ getTotalDiscountAmount() | number: '1.2-2' }}</span>
          </div>
           <div class="voucher-panel__summary-row" *ngIf="getTotalInceptiveAmount() > 0">
            <span>Total Incentive Amount</span>
            <span class="voucher-panel__summary-value">{{ getTotalInceptiveAmount() | number: '1.2-2' }}</span>
          </div>
          <div class="voucher-panel__summary-row">
            <span>Sub Total Amount</span>
            <span class="voucher-panel__summary-value">{{ getTotalAmount2() | number: '1.2-2' }}</span>
          </div>
          <div class="voucher-panel__summary-row">
            <span>Total GST Amount</span>
            <span class="voucher-panel__summary-value">{{ getTotalGSTAmount2() | number: '1.2-2' }}</span>
          </div>
          <div class="voucher-panel__summary-row">
            <span>
              Round
              {{ roundedamount2 < 0 ? 'Down' : (roundedamount2> 0 ? 'Up' : '') }}
              Amount
            </span>
            <span class="voucher-panel__summary-value">
              {{ roundedamount2 | number:'1.2-2' }}
            </span>
          </div>
          <div class="voucher-panel__summary-row">
            <span>Total Credit</span>
             <span class="voucher-panel__summary-value">{{ totalcredit2() | number: '1.2-2' }}</span>
          </div>
          <div class="voucher-panel__summary-row">
            <span>Total Debit</span>
            <span class="voucher-panel__summary-value">{{ getTotalRoundedAmount2() | number: '1.2-2' }}</span>
          </div>
          <div class="voucher-panel__summary-divider"></div>
          <div class="voucher-panel__summary-grand-label">Total Amount</div>
          <div class="voucher-panel__summary-grand">{{ getTotalAmount2() + getTotalGSTAmount2() | number: '1.2-2'  }}</div>
          <div class="voucher-panel__summary-words">{{ amountInWords }}</div>
          <div
            class="voucher-panel__summary-badge"
            [class.voucher-panel__summary-badge--ok]="isDebitCreditMatched"
            [class.voucher-panel__summary-badge--warn]="!isDebitCreditMatched">
            <mat-icon>{{ isDebitCreditMatched ? 'check_circle' : 'error' }}</mat-icon>
            {{ isDebitCreditMatched ? 'Debit/Credit Matched' : 'Debit/Credit Mismatch' }}
          </div>
        </ng-container>
        <ng-template #emptySummary>
          <div class="voucher-panel__summary-empty">Totals appear after line items are loaded.</div>
        </ng-template>
      </aside>
    </div>
  </div>

<app-ui-document-panel-footer
  [primaryActions]="footerPrimaryActions"
  [secondaryActions]="footerSecondaryActions"
  [destructiveAction]="footerDestructiveAction"
  [overflowActions]="footerOverflowActions"
  (actionClick)="onFooterAction($event)">
</app-ui-document-panel-footer>

</app-ui-document-panel-shell>
